import { exportsModule } from '@cian/mf-registry/browser';
import { createApplicationState } from '../services/applicationState';
import { createApplicationContext } from '../services/createApplicationContext';
import { createCustomElementConstructor } from './createCustomElementConstructor';

export function start() {
  const context = createApplicationContext();
  const store = createApplicationState(context);

  exportsModule({
    ui: {
      '/mortgage-mini-calculator/': () => ({
        customElementConstructor: createCustomElementConstructor(context, store),
      }),
    },
  });
}
